module.exports = __webpack_public_path__ + "5e111178f01f269670033cf45c3bdf5b.svg";